import { render, staticRenderFns } from "./studyHistoryData.vue?vue&type=template&id=9fb767b4&scoped=true&"
import script from "./studyHistoryData.vue?vue&type=script&lang=ts&"
export * from "./studyHistoryData.vue?vue&type=script&lang=ts&"
import style0 from "./studyHistoryData.vue?vue&type=style&index=0&id=9fb767b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb767b4",
  null
  
)

export default component.exports